import { Card } from "components/Card/Card";

import {
  AnimalCard as AnimalCardType,
  ExtensionType,
} from "backend/src/common/types/ExtensionCard";
import { AnimalCardModelType } from "store/models/AnimalCard";

import styles from "./styles.module.scss";
import { store } from "store/store";
import { GameStage } from "backend/src/common/types/roomState";
import { observer } from "mobx-react-lite";
import { getAnimalDefaultName } from "utils/getAnimalDefaultName";
import { getAnimalMeta } from "utils/getAnimalMeta";
import { renameAnimal } from "socket/events/renameAnimal";
import { useI18n } from "i18n/I18nProvider";
import { getAnimalFallbackImage } from "utils/getAnimalFallbackImage";

type AnimalCardSimpleProps = {
  card: AnimalCardModelType;
  index: number;
  other?: boolean;
};
export const AnimalCardSimple: React.FC<AnimalCardSimpleProps> = observer(
  ({ card, other, index }) => {
    const { locale } = useI18n();
    const foodNeededForAnimal = card.needToEat;

    const meta = getAnimalMeta(card, locale);
    const imageSrc =
      card.meta.generatedImageUrl ||
      getAnimalFallbackImage(card, card.extensions);

    return (
      <div className={styles.cardContainer}>
        <div className={styles.card}>
          <Card
            onTitleChange={
              !other ? (value) => renameAnimal(index, value) : undefined
            }
            title={
              card.meta.name ||
              getAnimalDefaultName(card as AnimalCardType, locale)
            }
            red={card.extensions.some(
              (extension) => extension.visibleType === ExtensionType.predator,
            )}
            blue={card.extensions.some(
              (extension) => extension.visibleType === ExtensionType.swimming,
            )}
            afterTitle={
              store.gameState.stage === GameStage.eating
                ? `${Math.min(
                    card.satiety,
                    foodNeededForAnimal,
                  )} / ${foodNeededForAnimal}`
                : foodNeededForAnimal
            }
          >
            <div className={styles.cardContent}>
              <div className={styles.meta}>{meta}</div>
              <div className={styles.image}>
                <img src={imageSrc} alt="" />
              </div>
              <div className={styles.panel}>
                {store.gameState.stage === GameStage.eating && (
                  <div
                    className={styles.progress}
                    style={{
                      width: `${Math.min(
                        100,
                        (100 * card.satiety) / foodNeededForAnimal,
                      )}%`,
                    }}
                  />
                )}
              </div>
            </div>
          </Card>
        </div>
      </div>
    );
  },
);
